"use client";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useState } from "react";
import { isServer } from "@travel/shared/utils";
export var useDetectInsideInteraction = function (callback, isActive, events) {
    if (isActive === void 0) { isActive = true; }
    if (events === void 0) { events = ["mousedown", "click", "touchstart"]; }
    var _a = __read(useState(), 2), node = _a[0], setNode = _a[1];
    var ref = useCallback(function (node) { return setNode(node); }, []);
    useEffect(function () {
        if (isServer || !node || !isActive)
            return;
        var isDestroyed = false;
        var handleInteraction = function (event) {
            var target = event.target;
            var isInside = node.contains(target);
            var isNode = node === target;
            callback(isInside, event, isNode);
        };
        setTimeout(function () {
            if (isDestroyed)
                return;
            events.forEach(function (event) {
                return window.addEventListener(event, handleInteraction);
            });
        });
        return function () {
            isDestroyed = true;
            events.forEach(function (event) {
                return window.removeEventListener(event, handleInteraction);
            });
        };
    }, [node, isActive, events.toString()]);
    return ref;
};
